import { autoinject, transient } from "aurelia-framework";
import { StepModel } from "../../../../models/basics/basics.models";
import { I18N } from "aurelia-i18n";
import { DayPartHelper } from "../../../../helpers/day-part.helper";
import { UserClientService } from "../../../../services/authentication/user-client.service";
import { InspectorsStepsEnum, InspectorsConstants } from "../../../../models/tasks/task.model";
import { InspectorsOverview } from "./tabs/inspector-overview";
import { InspectorDetails } from "./tabs/inspector-details";

@autoinject()
@transient()
export class Inspectors {

    public currentTab: StepModel;
    public currentStepKey: string = InspectorsConstants.TabsCacheKey;

    constructor(private i18N: I18N,
        private userClientService: UserClientService, private inspectorDetails: InspectorDetails,
        private overview: InspectorsOverview) {
        this.tabs = [
            {
                show: () => false,
                title: this.i18N.tr("overview-text"),
                step: InspectorsStepsEnum.Overview,
                vm: this.overview,
            },
            {
                show: () => true,
                title: this.i18N.tr("inspector-details-text"),
                step: InspectorsStepsEnum.Inspectors,
                vm: this.inspectorDetails
            }
        ];
    }

    activate() {
        if (window.history.state && Object.keys(window.history.state).indexOf(InspectorsConstants.historyInspectorsTabKey) > -1) {
            const tabListName = window.history.state[InspectorsConstants.historyInspectorsTabKey];
            let step: number = null;
            switch (tabListName) {
                case InspectorsConstants.Overview:
                    step = InspectorsStepsEnum.Overview;
                    break;
                case InspectorsConstants.InspectorsListName:
                    step = InspectorsStepsEnum.Inspectors;
                    break;
            }

            delete window.history.state[InspectorsConstants.historyInspectorsTabKey];
            window.history.replaceState(window.history.state, "Inspectors");

            if (step != null) {
                const tabs = this.tabs.filter(x => x.step == step);
                if (tabs && tabs.length > 0)
                    this.currentTab = tabs[0];
            }
        }
    }


    tabs: StepModel[];

    public getTitle() {
        return DayPartHelper.getCurrentDayPart() + ' ' + this.userClientService.currentUser.userName;
    }
}
